
















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class MessageDialog extends Vue {
    @Prop() btnText = ""
    @Prop() text = ""
    dialog = false
}
